export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9923_LAST_UPDATED': 'Last Updated',
    '_11126_LAST_UPDATED_BY': 'Last Updated By',
    '_7360_FILTER': 'Filter',
    '_7329_CREATED_ON': 'Created On',
    '_7330_CREATED_BY': 'Created By',
    '_9698_NOTE': 'Note',
    '_965_DATE': 'Date',
    '_9487_COMMITMENT_NARRATIVE': 'Commitment Narrative',
    '_9488_ADD_COMMITMENT_NOTE': 'Add Commitment Note',
    '_11127_LAST_UPDATED_ON': 'Last Updated On',
    '_10044_BY_DATE': 'By Date',
    '_11128_CREATED': 'Created',
    '_11129_DATE_FILTERS': 'Date Filters'
};
